<template>
  <div id="appNavbar">
    <v-navigation-drawer v-model="sideNav" fixed temporary width="290" color="#ffffff" class="drawer-container">
      <!-- Drawer Header -->
      <v-list-item class="px-4 py-3" style="background-color: #005f32;">
        <v-list-item-content>
          <a href="https://www.wti.org.in/" class="d-flex align-center">
            <v-img
              contain
              height="45px"
              position="left center"
              :src="require('./../../../public/wtilogo.png')"
            ></v-img>
          </a>
        </v-list-item-content>
        <v-list-item-action class="ma-0">
          <v-btn icon dark @click="sideNav = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>

      <!-- Navigation List -->
      <v-list nav dense class="py-2 drawer-menu-list">
        <template v-for="(item, i) in appNavItems">
          <!-- JOBS Dropgroup -->
          <v-list-group v-if="item.children" :key="i" no-action color="#005f32" class="drawer-group">
            <template v-slot:activator>
              <v-list-item-content class="text-left">
                <v-list-item-title class="popsemibold text-uppercase drawer-item-title">
                  {{ item.name }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(sub, j) in item.children"
              :key="j"
              :to="sub.route"
              @click="sideNav = false"
              active-class="green--text text--darken-3"
              class="pl-8"
            >
              <v-list-item-content class="text-left">
                <v-list-item-title class="popsemibold text-uppercase drawer-subitem-title">
                  {{ sub.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <!-- Donate Button Item -->
          <v-list-item v-else-if="item.highlight" :key="i" :href="item.route" class="my-2 mx-2 donate-drawer-item">
            <v-list-item-content class="text-left py-2">
              <v-list-item-title class="popsemibold text-uppercase donate-item-title">
                {{ item.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Cart Item -->
          <v-list-item v-else-if="item.isCart" :key="i" :to="item.route" @click="sideNav = false" class="my-1">
            <v-list-item-icon class="mr-3 align-self-center">
              <v-badge
                color="#60511e"
                small
                overlap
                :content="appCart ? appCart : '0'"
              >
                <v-icon color="#005f32">mdi-cart</v-icon>
              </v-badge>
            </v-list-item-icon>
            <v-list-item-content class="text-left">
              <v-list-item-title class="popsemibold text-uppercase drawer-item-title">
                {{ item.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Account Menu -->
          <v-list-item v-else-if="item.isAccount" :key="i" class="my-1">
            <v-list-item-content class="pa-0 text-left">
              <AccountMenu2 />
            </v-list-item-content>
          </v-list-item>

          <!-- External Links -->
          <v-list-item v-else-if="item.isExternal" :key="i" :href="item.route" class="my-1">
            <v-list-item-content class="text-left">
              <v-list-item-title class="popsemibold text-uppercase drawer-item-title">
                {{ item.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Internal Router Links -->
          <v-list-item v-else :key="i" :to="item.route" @click="sideNav = false" class="my-1">
            <v-list-item-content class="text-left">
              <v-list-item-title class="popsemibold text-uppercase drawer-item-title">
                {{ item.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <!-- Top App Bar for Mobile/Tablet (< 1264px) -->
    <v-app-bar
      app
      dark
      color="#005f32"
      height="70px"
      elevation="4"
      class="hidden-lg-and-up"
    >
      <a href="https://www.wti.org.in/" class="d-flex align-center">
        <v-img
          contain
          height="55px"
          width="130px"
          position="left center"
          :src="require('./../../../public/wtilogo.png')"
        ></v-img>
      </a>

      <v-spacer></v-spacer>

      <!-- Donate Button -->
      <v-btn
        href="https://donation.wti.org.in/"
        small
        color="#ecb338"
        class="mr-2 px-2 font-weight-bold"
        style="color: #60511e; letter-spacing: 1px; font-size: 11px;"
        elevation="0"
      >
        DONATE
      </v-btn>

      <!-- Cart Button -->
      <v-btn icon to="/productCart" class="mr-1">
        <v-badge
          overlap
          color="#60511e"
          small
          offset-x="6"
          offset-y="6"
          :content="appCart ? appCart : '0'"
        >
          <v-icon color="#ffffff">mdi-cart</v-icon>
        </v-badge>
      </v-btn>

      <!-- Menu Button -->
      <v-btn icon @click.stop="sideNav = !sideNav">
        <div style="padding: 6px; background-color: rgba(0, 0, 0, 0.2); border-radius: 4px;" class="d-flex align-center justify-center">
          <v-icon color="#ffffff">mdi-menu</v-icon>
        </div>
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
import AccountMenu2 from "./accountMenu2";

export default {
  components: {
    AccountMenu2,
  },
  data() {
    return {
      sideNav: false,
      navItems: [
        { name: "ABOUT US", route: "https://www.wti.org.in/", isExternal: true },
        { name: "OUR WORK", route: "https://www.wti.org.in/", isExternal: true },
        { name: "WHY US", route: "https://www.wti.org.in/why-us", isExternal: true },
        { name: "RESOURCE CENTRE", route: "https://www.wti.org.in/", isExternal: true },
        { name: "SHOP", route: "https://www.jobs.wti.org.in/Shopping", isExternal: true },
        { name: "CONTACT US", route: "https://www.wti.org.in/contact-us", isExternal: true },
        {
          name: "JOBS",
          children: [
            { name: "OPEN POSITIONS", route: "/", isExternal: false },
            { name: "CAREERS", route: "/career", isExternal: false },
          ],
        },
        { name: "DONATE", route: "https://donation.wti.org.in/", isExternal: true, highlight: true },
        { name: "MY CART", route: "/productCart", isExternal: false, isCart: true },
        { name: "Account", isAccount: true },
      ],
    };
  },
  computed: {
    appNavItems() {
      return this.navItems;
    },
    appCart() {
      return this.$store.state.cartItems;
    },
  },
};
</script>

<style scoped>
.drawer-container {
  text-align: left !important;
}

.drawer-menu-list {
  text-align: left !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.drawer-menu-list >>> .v-list-item {
  text-align: left !important;
  justify-content: flex-start !important;
  padding-left: 12px !important;
}

.drawer-menu-list >>> .v-list-item__title {
  text-align: left !important;
}

.drawer-menu-list >>> .v-list-item__content {
  text-align: left !important;
  align-items: flex-start !important;
}

.drawer-menu-list >>> .v-list-group__header {
  padding-left: 12px !important;
}

.drawer-item-title {
  font-size: 13px !important;
  letter-spacing: 1.5px !important;
  color: #272727 !important;
  text-align: left !important;
  font-family: 'poppinssemibold', sans-serif !important;
}

.drawer-subitem-title {
  font-size: 12px !important;
  letter-spacing: 1px !important;
  color: #4f4f4f !important;
  text-align: left !important;
  font-family: 'poppinssemibold', sans-serif !important;
}

.donate-drawer-item {
  background-color: #ecb338 !important;
  border-radius: 4px !important;
  padding-left: 16px !important;
}

.donate-item-title {
  font-size: 13px !important;
  letter-spacing: 2px !important;
  color: #60511e !important;
  font-weight: 700 !important;
  text-align: left !important;
}

.searchBox .v-input__control {
  min-height: 10px !important;
}

.searchBox .v-input__control .v-input__slot {
  padding: 0px !important;
}
</style>
